module.exports = __webpack_public_path__ + "img/green-sail-white.da79f9a9.svg";